import React, { useState, Suspense, useEffect, useRef } from "react";
import InputComponent from "../components/input-component/input-component";
import CompilationErrorsBox from "../components/compilation-errors";
import useStyles from "../components/styles";
import AutomaticTestingToolHeader from "../components/automatic-testing-tool-header";
import Disclaimer from "../components/disclaimer";
import store from "src/store";
import { requestJSON } from "src/utils/request-module";
import InputText from "src/components/input-text";
import { tasks } from "../../../shared/audit-process";
import { CircularProgress } from "@material-ui/core";

export default function AIReviewAgent() {
  var [doing,set_doing]=useState(false)

  var [taskStatus,set_taskStatus]=useState({})
  var mounted=useRef(true)

  useEffect(()=>{
    return ()=>{mounted.current=false}
  },[])
  
  async function start(){
    set_doing(true)
    await requestJSON('POST','/start-ai-agent')

    while(true) {
      var status=await requestJSON('POST','/ai-agent-status')
      if(!mounted.current) break
      set_taskStatus(status)
      await delay(200)
    }
  }

  return <div css={`
      display: flex;
      justify-content: center;
      align-items: center;
      width:100%;
      height:100%;
  `}>
  {doing &&
  <div css={` 
      margin-top:30px;
      text-align: left;     /* יישור לשמאל בתוך התיבה */
      padding: 20px;
      font-size:22px;
      `}>

      {[
        {id:'compile',text:'Compiling the smart contract'},
        {id:'abi',text:'Generate ABI'},
        {id:'Generate Formal Mapping',text:'Generate Formal Mapping'},
        {id:'Identify required simulations',text:'Identify required simulations'},
        {id:'Generate Simulations',text:'Generate Simulations'},
        {id:'Execute Simulations',text:'Execute Simulations'},
        {id:'Validating asset unlockability',text:'Validating asset unlockability'},
        {id:'Validating asset unlockability',text:'Validating asset unlockability'},
        {id:'Validating pausability',text:'Validating pausability'},
        {id:'Validating pausability1',text:'...'},
        {id:'Validating pausability2',text:'...'},
        {id:'Validating pausability3',text:'...'},
      ].map(x=><div 
      css={`margin-bottom:10px;`}
      key={x.id}>
        <div css={`display:inline-block;width:20px;`}>
        {taskStatus[x.id]=='working' && <CircularProgress size={20} />}
        {taskStatus[x.id]=='done' && <span css={`color:green;font-size:20px;`}>✔︎</span>}
        </div>
        &nbsp;
        {x.text}
        </div>)}
  </div>}
  {!doing  && <center
  onClick={start}
  css={`
    margin-top:20px;
    background:#FFEE00;
    padding:20px 40px;
    font-weight:bolder;
    border-radius:20px;
    border:1px solid black;
    vertical-align:middle;
    cursor:pointer;
    font-size:26px;`}>
    <svg width="36" height="36" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg" css={`vertical-align:middle;`}>
<path d="M48.45 7.12501C48.45 6.74708 48.2999 6.38462 48.0326 6.11739C47.7654 5.85015 47.4029 5.70001 47.025 5.70001C46.6471 5.70001 46.2846 5.85015 46.0174 6.11739C45.7501 6.38462 45.6 6.74708 45.6 7.12501V8.55001H44.175C43.7971 8.55001 43.4346 8.70015 43.1674 8.96739C42.9001 9.23462 42.75 9.59708 42.75 9.97501C42.75 10.3529 42.9001 10.7154 43.1674 10.9826C43.4346 11.2499 43.7971 11.4 44.175 11.4H45.6V12.825C45.6 13.2029 45.7501 13.5654 46.0174 13.8326C46.2846 14.0999 46.6471 14.25 47.025 14.25C47.4029 14.25 47.7654 14.0999 48.0326 13.8326C48.2999 13.5654 48.45 13.2029 48.45 12.825V11.4H49.875C50.2529 11.4 50.6154 11.2499 50.8826 10.9826C51.1499 10.7154 51.3 10.3529 51.3 9.97501C51.3 9.59708 51.1499 9.23462 50.8826 8.96739C50.6154 8.70015 50.2529 8.55001 49.875 8.55001H48.45V7.12501ZM19.95 15.675C19.95 16.0529 19.7999 16.4154 19.5326 16.6826C19.2654 16.9499 18.9029 17.1 18.525 17.1H17.1V18.525C17.1 18.9029 16.9499 19.2654 16.6826 19.5326C16.4154 19.7999 16.0529 19.95 15.675 19.95C15.2971 19.95 14.9346 19.7999 14.6674 19.5326C14.4001 19.2654 14.25 18.9029 14.25 18.525V17.1H12.825C12.4471 17.1 12.0846 16.9499 11.8174 16.6826C11.5501 16.4154 11.4 16.0529 11.4 15.675C11.4 15.2971 11.5501 14.9346 11.8174 14.6674C12.0846 14.4001 12.4471 14.25 12.825 14.25H14.25V12.825C14.25 12.4471 14.4001 12.0846 14.6674 11.8174C14.9346 11.5501 15.2971 11.4 15.675 11.4C16.0529 11.4 16.4154 11.5501 16.6826 11.8174C16.9499 12.0846 17.1 12.4471 17.1 12.825V14.25H18.525C18.9029 14.25 19.2654 14.4001 19.5326 14.6674C19.7999 14.9346 19.95 15.2971 19.95 15.675ZM45.6 41.325C45.6 41.7029 45.4499 42.0654 45.1826 42.3326C44.9154 42.5999 44.5529 42.75 44.175 42.75H42.75V44.175C42.75 44.5529 42.5999 44.9154 42.3326 45.1826C42.0654 45.4499 41.7029 45.6 41.325 45.6C40.9471 45.6 40.5846 45.4499 40.3174 45.1826C40.0501 44.9154 39.9 44.5529 39.9 44.175V42.75H38.475C38.0971 42.75 37.7346 42.5999 37.4674 42.3326C37.2001 42.0654 37.05 41.7029 37.05 41.325C37.05 40.9471 37.2001 40.5846 37.4674 40.3174C37.7346 40.0501 38.0971 39.9 38.475 39.9H39.9V38.475C39.9 38.0971 40.0501 37.7346 40.3174 37.4674C40.5846 37.2001 40.9471 37.05 41.325 37.05C41.7029 37.05 42.0654 37.2001 42.3326 37.4674C42.5999 37.7346 42.75 38.0971 42.75 38.475V39.9H44.175C44.5529 39.9 44.9154 40.0501 45.1826 40.3174C45.4499 40.5846 45.6 40.9471 45.6 41.325ZM38.2898 18.7131C37.7832 18.2061 37.1816 17.8038 36.5195 17.5294C35.8573 17.255 35.1476 17.1137 34.4309 17.1137C33.7141 17.1137 33.0044 17.255 32.3422 17.5294C31.6801 17.8038 31.0786 18.2061 30.572 18.7131L29.2125 20.0726L36.9275 27.7875L38.2898 26.4281C38.7964 25.9215 39.1982 25.3201 39.4724 24.6583C39.7466 23.9964 39.8877 23.287 39.8877 22.5706C39.8877 21.8542 39.7466 21.1448 39.4724 20.4829C39.1982 19.821 38.7964 19.2197 38.2898 18.7131ZM34.9125 29.8025L27.1976 22.0875L7.29885 41.9862C6.79228 42.4928 6.39045 43.0942 6.11629 43.756C5.84214 44.4179 5.70103 45.1273 5.70103 45.8437C5.70103 46.5601 5.84214 47.2695 6.11629 47.9313C6.39045 48.5932 6.79228 49.1946 7.29885 49.7012C7.80542 50.2077 8.40681 50.6096 9.06868 50.8837C9.73054 51.1579 10.4399 51.299 11.1563 51.299C11.8727 51.299 12.5821 51.1579 13.244 50.8837C13.9058 50.6096 14.5072 50.2077 15.0138 49.7012L34.9125 29.8025Z" fill="black"/>
</svg>
&nbsp;
<span css={`vertical-align:middle;`}>
    Start AI Testing
    </span>
    </center>}
    </div>
}

function delay(ms){return new Promise(resolve=>setTimeout(resolve,ms))}